// extracted by mini-css-extract-plugin
export default {"root":"root___TkdbB","logo":"logo___pdRrz"};